module.exports = __webpack_public_path__ + "img/thank-you.342aaa23.svg";